module.exports = __webpack_public_path__ + "static/preload-d7ce2a5abcff6c3291b273ec2cc0b3c3.png";